var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "variation-list-item", attrs: { "two-line": "" } },
    [
      _c("div", { staticClass: "variation-list-item-content" }, [
        _c(
          "div",
          { staticClass: "variation-header" },
          [
            _c("v-list-item-title", [
              _vm._v(
                "Data: " +
                  _vm._s(
                    _vm._f("formatDateTime")(_vm.variazione.dateTracking)
                  ) +
                  " "
              ),
            ]),
            _vm.variazione.previousCount
              ? _c("v-list-item-subtitle", [
                  _vm._v('Numero elementi precedenti: "'),
                  _c("strong", [_vm._v(_vm._s(_vm.variazione.previousCount))]),
                  _vm._v('"'),
                ])
              : _vm._e(),
            _vm.variazione.currentCount
              ? _c("v-list-item-subtitle", [
                  _vm._v('Numero elementi attuali: "'),
                  _c("strong", [_vm._v(_vm._s(_vm.variazione.currentCount))]),
                  _vm._v('"'),
                ])
              : _vm._e(),
            _c(
              "v-btn",
              {
                staticStyle: { color: "white" },
                attrs: { color: "green lighten-2" },
                on: { click: _vm.confermaVariazione },
              },
              [_vm._v(" Conferma variazione ")]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "difference-list" },
          [
            _vm._l(
              _vm.variazione.addedItemsDisplayValue,
              function (addedElement, k) {
                return _c(
                  "div",
                  { key: k, staticClass: "difference-item" },
                  [
                    _c("v-icon", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(" mdi-chevron-right"),
                    ]),
                    _c("div", [
                      _vm._v(
                        " E' stato aggiunto un elemento con " +
                          _vm._s(_vm.displayProperty) +
                          " pari a "
                      ),
                      _c("strong", [_vm._v('"' + _vm._s(addedElement) + '"')]),
                    ]),
                  ],
                  1
                )
              }
            ),
            _vm._l(
              _vm.variazione.removedItemsDisplayValue,
              function (removedElement, k) {
                return _c(
                  "div",
                  { key: k, staticClass: "difference-item" },
                  [
                    _c("v-icon", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(" mdi-chevron-right"),
                    ]),
                    _c("div", [
                      _vm._v(
                        " E' stato rimosso un elemento con " +
                          _vm._s(_vm.displayProperty) +
                          " pari a "
                      ),
                      _c("strong", [
                        _vm._v('"' + _vm._s(removedElement) + '"'),
                      ]),
                    ]),
                  ],
                  1
                )
              }
            ),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }